/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { LicensesDto } from '../models/licenses-dto';
import { licensesGetLicenses } from '../fn/licenses/licenses-get-licenses';
import { LicensesGetLicenses$Params } from '../fn/licenses/licenses-get-licenses';

@Injectable({ providedIn: 'root' })
export class LicensesApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `licensesGetLicenses()` */
  static readonly LicensesGetLicensesPath = '/api/licenses';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `licensesGetLicenses()` instead.
   *
   * This method doesn't expect any request body.
   */
  licensesGetLicenses$Response(params?: LicensesGetLicenses$Params, context?: HttpContext): Observable<StrictHttpResponse<LicensesDto>> {
    const obs = licensesGetLicenses(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `licensesGetLicenses$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  licensesGetLicenses(params?: LicensesGetLicenses$Params, context?: HttpContext): Observable<LicensesDto> {
    const resp = this.licensesGetLicenses$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<LicensesDto>): LicensesDto => r.body)
    );
  }

}
